"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  deleted: 'Deleted',
  closed: 'The user profile is in the closed mode. Information is not available for viewing'
};